import { EProductType } from 'v2/interfaces/product';
import { ruleRunner } from 'validations/ruleRunner';
import { required, minimun, ruleIfValue } from 'validations/rules';

const Validations = [
  ruleRunner(
    'price',
    'preço',
    required,
    ruleIfValue('type', EProductType.SERVICE, minimun('0.01')),
    ruleIfValue('type', EProductType.TICKET, minimun('0.01')),
    ruleIfValue('type', EProductType.DIGITAL, minimun('1.00')),
    ruleIfValue('type', EProductType.PHYSICAL, minimun('1.00'))
  ),
];

export default Validations;
